export const es = {
  interviewInstructions: {
    title: "Preparándote para tu Entrevista en Video",
    description:
      "Completa estos 4 sencillos pasos para asegurar una experiencia de entrevista en video sin problemas.",
    steps: [
      {
        title: "Configura tus dispositivos",
        description:
          "Permite los permisos del navegador y asegúrate de que tu cámara y micrófono funcionen correctamente.",
      },
      {
        title: "Comienza tu entrevista",
        description: "Haz clic en 'Iniciar Entrevista.'",
        tooltip:
          "La grabación comenzará automáticamente cuando hagas clic en el botón. No necesitas iniciar/detener la grabación manualmente.",
      },
      {
        title: "Responde cada pregunta",
        description:
          "Cada pregunta aparecerá en pantalla. Habla tu respuesta claramente. No necesitas escribir tus respuestas.",
      },
      {
        title: "Avanza por todas las preguntas",
        description:
          "Haz clic en 'Siguiente Pregunta' para continuar. Responderás {count} preguntas.",
      },
    ],
    buttonText: "Entendido",
  },
  previewScreen: {
    title: "Estás a punto de comenzar",
    description:
      "El siguiente paso es completar una entrevista en video rápida con nuestro asistente de IA. Por favor revisa estas recomendaciones antes de tu entrevista: tómate tiempo para responder cada pregunta, y recuerda que la entrevista podría durar alrededor de 20 minutos en total.",
    microphoneTest: {
      title: "Prueba de Micrófono",
      description:
        'Haz clic en "Iniciar Grabación" y habla claramente por unos segundos. Un indicador visual mostrará tu nivel de volumen. La grabación se detiene automáticamente después de 10 segundos.',
      startRecording: "Iniciar Grabación",
      recording: "Grabando...",
      playRecording: "Reproducir Grabación",
      reset: "Reiniciar",
      recordingTime: "Tiempo de Grabación",
    },
    aboutProcess: {
      title: "Sobre el proceso",
      steps: [
        "Haz clic en 'Iniciar Entrevista.' La grabación comienza automáticamente, sin opción de iniciar, pausar o detener manualmente. Todas las respuestas son grabadas en video, cubriendo preguntas técnicas y de comportamiento para una evaluación completa de habilidades.",
        'Responde a cada pregunta en video. Usa "Siguiente Pregunta" para avanzar. Completa todas las {count} preguntas para finalizar.',
      ],
    },
    checkbox: {
      label:
        "Cumplo con los requisitos mencionados para iniciar esta entrevista.",
    },
    multipleCamera: {
      title: "Múltiples Cámaras Detectadas",
      description:
        "Se han detectado múltiples cámaras. Por favor asegúrate de que la cámara correcta esté seleccionada y encendida, ya que es importante para evaluar adecuadamente la entrevista.",
      close: "Cerrar",
      configure: "Configurar",
    },
    previewName: {
      startInterview: "Comenzar entrevista ahora",
      nextQuestion: "Siguiente pregunta",
      scheduleInterview: "Agendar Entrevista",
    },
  },
  leaveRoom: {
    finishProcess: "Finalizar proceso",
    nextQuestion: "Siguiente pregunta",
    skipQuestion: "Saltar pregunta",
    confirmSkip: "¿Estás seguro de que quieres saltar esta pregunta?",
    confirmNext:
      "¿Estás seguro de que quieres continuar con la siguiente pregunta?",
    finalWarning: "Esta acción es definitiva — no podrás volver atrás.",
    cancel: "Cancelar",
    confirm: "Confirmar",
    noAudioModal: {
      title: "No se Detectó Audio",
      description:
        "No se ha detectado audio en los últimos 25 segundos. Por favor asegúrate de que tu micrófono esté funcionando correctamente.",
      close: "Cerrar",
      configure: "Configurar",
    },
  },
  polls: {
    questionForm: {
      questionNumber: "Pregunta",
      of: "de",
      questionType: "Tipo de Pregunta",
      placeholder: "Haz una pregunta",
      options: "Opciones",
      optionsHint: "(Usa casillas para indicar respuestas correctas)",
      addOption: "Agregar Opción",
      notRequired: "No es obligatorio responder",
      save: "Guardar",
      deleteQuestion: "¿Eliminar pregunta?",
      deleteConfirm:
        "¿Estás seguro de que quieres eliminar esta pregunta? Esta acción no se puede deshacer.",
      cancel: "Cancelar",
      delete: "Eliminar",
    },
    savedQuestion: {
      edit: "Editar",
    },
  },
  conference: {
    initializingRecording: "Inicializando grabación",
    recording: "Grabando",
    question: "Pregunta",
    of: "de",
    answerInLanguage: "Por favor responde esta pregunta en",
    copyNotAllowed:
      "No está permitido copiar las preguntas, tu intento ha sido registrado. 🚨",
    languages: {
      English: "Inglés",
      Spanish: "Español",
      Español: "Español",
    },
  },
};
